/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SkeletonLoader from 'shared/components/ui/SkeletonLoader';

const ProductProperties = ({ properties, product, isLoadingProduct }) => {
  const { t } = useTranslation();
  const [featureToggle, setFeatureToggle] = useState(false);

  // Show skeleton loading during server fetch or data extraction/enhancement
  const isLoading = isLoadingProduct || product.status === 'EXTRACTING' || product.isEnhancingInProgress;

  if (isLoading) {
    return <SkeletonLoader type='basic' count={3} />;
  }

  return properties.length || product.features?.length ? (
    <div className='mt-8 mt-md-12 product-properties-container'>
      <p className='text-md text-lg-lg fw-500 mb-3 mb-md-6'>{t('title_features')}</p>
      {properties.map((item, i) => {
        if (!featureToggle && i > 3) return null;
        return (
          <div className='property-item' key={i}>
            <p className='mb-2 mb-md-3 text-sm text-md-lg'>
              <b className='text-capitalize'>{item.name}</b>: {item.value}
            </p>
          </div>
        );
      })}
      {!properties.length && !product.features && '-'}
      {product.features && (featureToggle || (!properties || properties.length <= 4)) && (
        <ul className='text-capitalize text-sm text-md-lg'>
          {product.features.map((item, i) => {
            return (
              <li className='mb-2 mb-md-3 property-item' key={i}>
                <b>{item}</b>
              </li>
            );
          })}
        </ul>
      )}
      {properties.length > 4 && (
        <span
          className='fw-500 cursor-pointer mt-1 mt-md-2 d-flex text-primary text-sm text-md-lg'
          onClick={() => setFeatureToggle(!featureToggle)}
        >
          {featureToggle ? t('text_read_less') : t('text_read_more')}
        </span>
      )}
    </div>
  ) : null;
};

export default ProductProperties;
